/** Left / right part of a symmetric pair (L = −x in game space). */
export type DozerSide = 'L' | 'R';

/**
 * Node contract of VEH_DOZER_A – the published GLB (tools/blender/assets/VEH_05_Catapillar.py) and its greybox
 * fallback carry the same names; the dozer's presentation relies on these names only:
 *
 *   VEH_DOZER_A                       root: ground centre of the tracks, front = +z
 *   VEH_DOZER_A_PIVOT_BLADE           push-arm trunnion, turns about its local x (a positive lift raises the blade);
 *                                     children: the blade, the cylinder rods, the blade tip socket
 *   VEH_DOZER_A_CYL_<L|R>_BARREL      child of the root, origin at the body-side eye, local +y towards the rod
 *   VEH_DOZER_A_CYL_<L|R>_ROD         child of the blade pivot, origin at the blade-side eye, local +y towards the barrel
 *                                     – the game aims both at each other every frame: the cylinder telescopes
 *   VEH_DOZER_A_TRACK_<L|R>           rubber belts: UV v along the belt, v = 1 per DozerConfig.vehicle.trackTileLength m
 *   VEH_DOZER_A_WHEEL_*               sprockets and rollers: turn about their local x, radius = half their box height
 *   VEH_DOZER_A_SOCKET_SEAT           the rider's hips / the root of ANIM_Drive, looking +z
 *   VEH_DOZER_A_SOCKET_BLADE_TIP      middle of the cutting edge (child of the pivot) – the pile grows in front of it
 *   VEH_DOZER_A_SOCKET_EXHAUST        exhaust cap – the smoke rises there
 */
export const DOZER_RIG = {
  root: 'VEH_DOZER_A',
  body: 'VEH_DOZER_A_BODY',
  pivotBlade: 'VEH_DOZER_A_PIVOT_BLADE',
  blade: 'VEH_DOZER_A_BLADE',
  bladeTip: 'VEH_DOZER_A_SOCKET_BLADE_TIP',
  seat: 'VEH_DOZER_A_SOCKET_SEAT',
  exhaust: 'VEH_DOZER_A_SOCKET_EXHAUST',
  wheelPrefix: 'VEH_DOZER_A_WHEEL_',
  cylinderBarrel: (side: DozerSide) => `VEH_DOZER_A_CYL_${side}_BARREL`,
  cylinderRod: (side: DozerSide) => `VEH_DOZER_A_CYL_${side}_ROD`,
  track: (side: DozerSide) => `VEH_DOZER_A_TRACK_${side}`,
} as const;

export const DOZER_SIDES: readonly DozerSide[] = ['L', 'R'];
